import { createSelector } from '@reduxjs/toolkit';

import { rootStateBranchSelector } from '../rootStateBranchSelector';

export const getBanners = rootStateBranchSelector('banners');

export const bannersHashSelector = createSelector(getBanners, state => state.hash);
